import {SET_SUBMITTED} from '../reducers/usrfields.js';

export default function setsubmitted(value){
    switch(value){
        case true:
            return{
                'type': SET_SUBMITTED,
                'value': true
            }
        default:
            return {
                'type': SET_SUBMITTED,
                'value': false,
            }
    }
}

